/**
 * Returns a given css class if the current location is part of the desired routes
 * @param activeRoutes
 * @param location
 * @param className
 * @returns
 */
export const getActiveRouteClass = (activeRoutes: string[], location: string, className: string) =>
  activeRoutes.includes(location) ? className : ''

export const getActiveSubRouteClass = (activeRoutes: string[], location: string, className: string) => {
  for (const route of activeRoutes) {
    if (location.startsWith(route)) {
      return className
    }
  }
  return ''
}

export type GetActiveClassFunc = typeof getActiveRouteClass
